import { render } from "./TextBlock.vue?vue&type=template&id=7cc5ad23&scoped=true&ts=true"
import script from "./TextBlock.vue?vue&type=script&lang=ts"
export * from "./TextBlock.vue?vue&type=script&lang=ts"

import "./TextBlock.vue?vue&type=style&index=0&id=7cc5ad23&lang=scss&scoped=true"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cc5ad23"]])

export default __exports__